// extracted by mini-css-extract-plugin
export default {"action-wrapper":"CandidateTable_action-wrapper__YAvqp"};